import styled from 'styled-components';

export const StyledEnvelopeImage = styled.img`
  width: 120px;
  flex: 1 0 105px;
`;
